import { kumbh2025Page, kumbh2025PageChildren } from './page-kumbh-2025';
import { PageRoutes } from './page-routes';
import { theCampPage, theCampPageChildren } from './page-the-camp';
import { Page } from './pages-types';

const allPages = [
  theCampPage,
  theCampPageChildren,
  kumbh2025Page,
  kumbh2025PageChildren,
].flat();

export class PageStore {
  pages = new Map<PageRoutes, Page>(allPages.map((p) => [p.path, p]));

  getPageOrThrow = (path: PageRoutes) => {
    const page = this.pages.get(path);
    if (!page) {
      throw Error('page not found');
    }

    return page;
  };
}

export const pageStore = new PageStore();
